// extracted by mini-css-extract-plugin
export default {"form":"SignForm_form__HuF5M"};